var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"verify-payment-page"}},[_c('div',{staticClass:"main-container p-3"},[_vm._v("Verifying ... Please wait.")])])}]

export { render, staticRenderFns }